<swiper-container [pagination]="{ clickable: true }" navigation="true" [slidesPerView]="1" class="image-carousel" (swiperslidechange)="activeindexchange($event)" #swiper>
  @for (photoUrl of imageUrls; track photoUrl){
    <swiper-slide>
      <img data-src="{{photoUrl}}" class="swiper-lazy slide-image" loading="lazy"/>
    </swiper-slide>
  }
</swiper-container>
  